package kangaroorewards.appsdk.core.utils

import kangaroorewards.appsdk.core.SdkContext

object Configuration {

    fun getServerHostUrl(serverHostId : Int): String{
        return when(serverHostId){
            0 -> getBaseUrl()
            1 -> getIntegrationUrl()

            else -> getBaseUrl()
        }
    }

    fun getBaseUrl(): String {
        return when (SdkContext.environment) {
            "production" -> {
                "https://api.kangaroorewards.com/"
            }
            "staging" -> {
                "https://api-stg.traktrok.com/"
            }
            "development" -> {
                "https://api-dev.traktrok.com/"
            }
            else -> {
                "https://api.kangaroorewards.com/"
            }
        }
    }

    private fun getIntegrationUrl(): String {
        return when (SdkContext.environment) {
            "production" -> {
                "https://integrations.kangarooapis.com/"
            }
            "staging" -> {
                "https://integrations.kangarooapis.com/"
            }
            "development" -> {
                "https://integ-api-dev.traktrok.com/"
            }
            else -> {
                "https://integ-api-dev.traktrok.com/"
            }
        }
    }
}
